import m from "../../../../geodata/es2015/region/usa/riHigh";
window.am4geodata_region_usa_riHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/riHigh.js
// module id = null
// module chunks = 